import {FC} from "react";

interface IntelligenceActivityProps {
    steps: string[];
    isComplete: boolean;
}

const IntelligenceActivity: FC<IntelligenceActivityProps> = ({
    steps,
    isComplete
}) => {
    if (steps.length === 0) {
        return null;
    }

    if (!isComplete) {
        return (
            <div className="pi-activity">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className={`pi-activity__step${
                            index === steps.length - 1
                                ? " pi-activity__step--active"
                                : " pi-activity__step--done"
                        }`}
                    >
                        {index === steps.length - 1 && (
                            <span className="pi-activity__spinner" aria-hidden="true" />
                        )}
                        {step}
                    </div>
                ))}
            </div>
        );
    }

    return (
        <details className="pi-activity-expander">
            <summary className="pi-activity-expander__summary">Show steps</summary>
            <div className="pi-activity pi-activity--done">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className="pi-activity__step pi-activity__step--done"
                    >
                        {step}
                    </div>
                ))}
            </div>
        </details>
    );
};

export default IntelligenceActivity;
